import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CustomerType, DistinguishSupportService, ProductsState, UserService} from '../../../shared';
import {Store} from '@ngrx/store';
import {State} from '../../../../reducers/root/root.reducer';
import {take} from 'rxjs/operators';
import {Observable} from 'rxjs';
import * as ProductsAction from '../../../shared/reducers/products/products.actions';

@Component({
    selector: 'sl-reclamation-start',
    templateUrl: './reclamation-start.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReclamationStartComponent implements OnInit {

    public userId: string = undefined;
    public reclamationsWithoutSerialsEnabled: boolean;
    public massClaimAllowed: boolean;
    public businessUser: boolean;
    public CustomerType = CustomerType;

    private enterSerialsLater: boolean;
    private products$: Observable<ProductsState>;
    private user: any;

    get customerType(): CustomerType {
        return this.user.customerType;
    }

    constructor(private router: Router,
                private route: ActivatedRoute,
                private store: Store<State>,
                private userService: UserService,
                private distinguishSupportService: DistinguishSupportService) {
        if (this.distinguishSupportService.support) {
            this.user = JSON.parse(sessionStorage.getItem('user'));
        } else {
            this.user = JSON.parse(sessionStorage.getItem('currentUser'));
        }

        this.reclamationsWithoutSerialsEnabled = this.distinguishSupportService.support
            ? this.user.customerType !== CustomerType.Private
            : this.user.reclamationsWithoutSerialsEnabled;

        this.massClaimAllowed = this.user.massClaimAllowed;
        this.products$ = this.store.select('products');
    }

    ngOnInit(): void {
        this.redirectGuests();
        this.products$.pipe(take(1)).subscribe((products) => {
            this.enterSerialsLater = products.enterSerialsLater;
        });
        this.userId = this.route.snapshot.params.id;
    }

    private redirectGuests() {
        if (this.user.customerType === CustomerType.Guest) {
            this.proceedToProductIdentification();
        }

        this.businessUser = this.user.customerType === CustomerType.Commercial;

    }

    public proceedToProductIdentification(): void {
        if (this.enterSerialsLater) {
            this.store.dispatch(new ProductsAction.EnterSerialsLaterAction(false));
        }
        this.store.dispatch(new ProductsAction.DeleteAllProductAction());
        this.userId
            ? this.router.navigateByUrl('/produkte/identifikation/' + this.userId)
            : this.router.navigate(['/produkte', 'identifikation']);
    }

    public proceedToSimpleIdentifikation(): void {
        this.store.dispatch(new ProductsAction.DeleteAllProductAction());
        this.router.navigate([this.userId ? '/produkte/identifizierung-vereinfacht/' + this.userId : '/produkte/identifizierung-vereinfacht']);
    }

    public proceedToSerialnumbersCallOrder(): void {
        this.router.navigate(['/produkte', 'seriennummern-abrufauftrag']);
    }

}
